import { Pipe, PipeTransform, inject } from '@angular/core';

import { EnvironmentConfig } from '../client-config';

@Pipe({
    name: 'toSrcSet',
})
export class SrcsetPipe implements PipeTransform {
    private env = inject(EnvironmentConfig);

    transform(image: string, srcSetSizes: string[]): string {
        const imgId = image.substring(image.indexOf('/$-$/') + '/$-$/'.length);
        const quality = 85;
        return srcSetSizes
            .map((size) => {
                return `https://scmedia${this.env.configuration.DOMAIN}/cdn-cgi/image/width=${size},quality=${quality}/$-$/${imgId} ${size}w`;
            })
            .join(',');
    }
}
